<template>
	<v-app>
		<template v-if="isAboutPage">
			<v-main app>
				<transition name="fade" mode="out-in">
					<router-view></router-view>
				</transition>
				<app-loading :loading="loading"></app-loading>
			</v-main>
		</template>
		<template v-else>
			<app-toolbar></app-toolbar>

			<app-drawer></app-drawer>

			<v-main
				v-resize="calculateFooterHeight"
				app
				:style="'padding-bottom: ' + footerHeight"
			>
				<transition name="fade" mode="out-in">
					<router-view :key="$route.path"></router-view>
				</transition>
				<app-loading :loading="loading"></app-loading>
			</v-main>
		</template>

		<!-- <app-bottom-nav></app-bottom-nav> -->

		<app-notifier :notifier="notifier"></app-notifier>

		<app-notifier-f-c-m :notifier="notifierFCM"></app-notifier-f-c-m>

		<app-footer v-if="!isAboutPage"></app-footer>
	</v-app>
</template>

<script>
import client from "@/client";
import AppLoading from "@/components/app/AppLoading";
import AppDrawer from "@/components/app/AppDrawer";
import AppToolbar from "@/components/app/AppToolbar";
import AppFooter from "@/components/app/AppFooter";
import AppNotifier from "@/components/app/AppNotifier";
import AppNotifierFCM from "@/components/app/AppNotifierFCM";
import { getCookie, setCookie } from "@/utils/cookie-utils";

import firebase from "firebase/app";
import "firebase/app";
import "firebase/messaging";

export default {
	name: "App",
	components: {
		AppLoading,
		AppDrawer,
		AppToolbar,
		AppNotifier,
		AppNotifierFCM,
		AppFooter
	},
	data() {
		return {
			footerHeight: "100px",
			footerCheck: null
		};
	},
	computed: {
		loading() {
			return this.$store.state.loading;
		},
		isAboutPage() {
			return this.$route.name == "about";
		},
		notifier() {
			return this.$store.state.notification;
		},
		notifierFCM() {
			return this.$store.state.notificationFCM;
		}
	},
	created() {
		var firebaseConfig = {
			apiKey: "AIzaSyBDGukqwnEtH3D2e10aE3uA8uvqviMirZg",
			authDomain: "ertiqa-9f713.firebaseapp.com",
			databaseURL: "https://ertiqa-9f713.firebaseio.com",
			projectId: "ertiqa-9f713",
			storageBucket: "ertiqa-9f713.appspot.com",
			messagingSenderId: "204312771626",
			appId: "1:204312771626:web:e51dbfececea86eaf6d753",
			measurementId: "G-3R7HX9HG2H"
		};

		firebase.initializeApp(firebaseConfig);
		if (firebase.messaging.isSupported() == false) {
			setTimeout(() => {
				console.log("messaging/unsupported-browser")
			}, 500);
		} else {
			setTimeout(() => {
				console.log("messaging is supported");
			}, 500);
		}

		try {
			this.initMessaging();
		} catch (error) {
			console.log("messaging is NOT supported");
		}
	},
	mounted() {
		this.getSystemInfo();
		this.getContactInfo();
		this.$store.dispatch("setToken", getCookie("token"));
		this.footerCheck = setInterval(() => {
			// todo
			// update vuetify and check again
			// if fixed, remove this dirty fix!
			this.calculateFooterHeight();
		}, 250);

		this.getConfigViewCount();
	},
	methods: {
		getConfigViewCount() {
			client
				.get("/api/system/viewCount")
				.then(response => {
					console.log(response);
					this.$store.dispatch("setViewCount", response.data);
				})
				.catch(err => {
					console.log(err);
				});
		},
		initMessaging() {
			const messaging = firebase.messaging();

			messaging
				.requestPermission()
				.then(() => messaging.getToken())
				.then(token => {
					console.log("messaging token:");
					console.log(token); // Receiver Token to use in the notification
					
					const oldToken = getCookie('firebase-messaging-token');
					if (oldToken == "") {
						this.subscribeUserToNotification(token);
					} else if(oldToken == token){
						console.log("already subscribed");
					} else {
						this.updateUserNotificationToken(token, oldToken)
					}
				})
				.catch(function(err) {
					console.log("Unable to get permission to notify.", err);
				});

			messaging.onTokenRefresh(() => {
				messaging
					.getToken()
					.then(refreshedToken => {
						console.log("Token refreshed.");
						setTokenSentToServer(false);
						sendTokenToServer(refreshedToken);
					})
					.catch(err => {
						console.log("Unable to retrieve refreshed token ", err);
					});
			});

			messaging.onMessage(payload => {
				console.log("Message received. ", payload);

				this.$store.dispatch("notifyFCM", payload.notification);
			});

			function sendTokenToServer(currentToken) {
				console.log(currentToken);
				if (!isTokenSentToServer()) {
					console.log("Sending token to server...");
					setTokenSentToServer(true);
				} else {
					console.log(
						"Token already sent to server so won't send it again " +
							"unless it changes"
					);
				}
			}

			function isTokenSentToServer() {
				return window.localStorage.getItem("sentToServer") === "1";
			}

			function setTokenSentToServer(sent) {
				window.localStorage.setItem("sentToServer", sent ? "1" : "0");
			}

			function deleteToken() {
				messaging
					.getToken()
					.then(currentToken => {
						messaging
							.deleteToken(currentToken)
							.then(() => {
								console.log("Token deleted.");
								setTokenSentToServer(false);
							})
							.catch(err => {
								console.log("Unable to delete token. ", err);
							});
					})
					.catch(err => {
						console.log(
							"Error retrieving Instance ID token. ",
							err
						);
					});
			}

			console.log(deleteToken);
		},
		calculateFooterHeight() {
			if (this.isAboutPage) {
				return 0;
			}

			var footer = document.getElementsByClassName("v-footer")[0];
			if (footer == undefined) {
				clearInterval(this.footerCheck);
				return 0;
			}

			var height = footer.offsetHeight;
			var offset = 20;
			if (this.isAboutPage) {
				offset = 0;
			}
			this.footerHeight = height + offset + "px";
		},
		subscribeUserToNotification(token){
			var nAgt = navigator.userAgent;
			var browserName  = navigator.appName;
			var fullVersion  = ''+parseFloat(navigator.appVersion); 
			var majorVersion = parseInt(navigator.appVersion,10);
			var nameOffset,verOffset,ix;

			if ((verOffset=nAgt.indexOf("Opera"))!=-1) {
				browserName = "Opera";
				fullVersion = nAgt.substring(verOffset+6);
				if ((verOffset=nAgt.indexOf("Version"))!=-1) 
					fullVersion = nAgt.substring(verOffset+8);
			}
			else if ((verOffset=nAgt.indexOf("MSIE"))!=-1) {
				browserName = "Microsoft Internet Explorer";
				fullVersion = nAgt.substring(verOffset+5);
			}
			else if ((verOffset=nAgt.indexOf("Chrome"))!=-1) {
				browserName = "Chrome";
				fullVersion = nAgt.substring(verOffset+7);
			}
			else if ((verOffset=nAgt.indexOf("Safari"))!=-1) {
				browserName = "Safari";
				fullVersion = nAgt.substring(verOffset+7);
				if ((verOffset=nAgt.indexOf("Version"))!=-1) 
					fullVersion = nAgt.substring(verOffset+8);
			}
			else if ((verOffset=nAgt.indexOf("Firefox"))!=-1) {
				browserName = "Firefox";
				fullVersion = nAgt.substring(verOffset+8);
			}
			else if ( (nameOffset=nAgt.lastIndexOf(' ')+1) < (verOffset=nAgt.lastIndexOf('/')) ) {
				browserName = nAgt.substring(nameOffset,verOffset);
				fullVersion = nAgt.substring(verOffset+1);
				if (browserName.toLowerCase()==browserName.toUpperCase()) {
					browserName = navigator.appName;
				}
			}
			if ((ix=fullVersion.indexOf(";"))!=-1)
				fullVersion=fullVersion.substring(0,ix);
			if ((ix=fullVersion.indexOf(" "))!=-1)
				fullVersion=fullVersion.substring(0,ix);

			majorVersion = parseInt(''+fullVersion,10);
			if (isNaN(majorVersion)) {
				fullVersion  = ''+parseFloat(navigator.appVersion); 
				majorVersion = parseInt(navigator.appVersion,10);
			}

			const data = { OS:browserName, token: token };

			client
				.post("/api/notification/subscribe", data)
				.then(response => {
					setCookie('firebase-messaging-token', token)
					this.$store.dispatch("notify", {
						message: response.data.message
					});
				})
		},
		updateUserNotificationToken(newToken, oldToken) {
			client
				.get(`/api/notification/updateToken/${oldToken}/${newToken}`)
				.then(response => {
					setCookie('firebase-messaging-token', newToken)
					this.$store.dispatch("notify", {
						message: response.data.message
					});
				})
		},
		getSystemInfo() {
			client
				.get("/api/system/info")
				.then(response => {
					console.log(response);
					this.$store.dispatch("setSystemInfo", response.data.data);
				})
				.catch(err => {
					console.log(err);
					this.$store.dispatch("notify", {
						message: "Error: System info not loaded",
						color: "error"
					});
				});
		},
		getContactInfo() {
			client
				.get("/api/system/allcontacts")
				.then(response => {
					console.log(response);
					var media = response.data.data.map(item => {
						if (item.name == "الفيس بوك") {
							item.icon = "mdi-facebook";
						} else if (item.name == "تويتر") {
							item.icon = "mdi-twitter";
						} else if (item.name == "الواتساب") {
							item.icon = "mdi-whatsapp";
						} else if (item.name == "التلجرام") {
							item.icon = "mdi-telegram";
						} else if (item.name == "iOS App Store") {
							item.icon = "mdi-apple";
						} else if (item.name == "Android Play Store") {
							item.icon = "mdi-android";
						} else if (item.name == "رقم الجوال") {
							item.icon = "mdi-cellphone";
						} else if (item.name == "الهاتف") {
							item.icon = "mdi-phone";
						} else if (item.name == "البريد الإلكتروني") {
							item.icon = "mdi-email";
						}
						return item;
					});
					this.$store.dispatch("setContactInfo", media);
				})
				.catch(err => {
					console.log(err);
					this.$store.dispatch("notify", {
						message: "Error: Contact info not loaded",
						color: "error"
					});
				});
		}
	}
};
</script>

<style src="./styles.css"></style>